<!-- 2 columns form -->
<form name="accountform" [formGroup]="accountForm" novalidate>
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Accounts</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" (click)="reset()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-6">


          <fieldset>
            <legend class="text-semibold">
              <i class="icon-list position-left"></i> Accounts
            </legend>


            <table class="table datatable-column-search-inputs">
              <thead>
                <tr>
                  <th>Bank</th>
                  <th>Accronym</th>
                  <th>Account Number</th>
                  <th>Remark</th>
                  <th>Status</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let account of accounts | paginate: { id: 'accounts',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                  <td>{{account?.bank}}</td>
                  <td>{{account?.accronym}}</td>
                  <td>{{account?.account_number}}</td>
                  <td>{{account.remark}}</td>
                  <td>
                    <span class="label label-block label-default"
                      *ngIf="account.status === 'Pending' || account.status === 'pending'">{{account.status}}</span>
                    <span class="label label-block bg-primary"
                      *ngIf="account.status === 'Active' || account.status === 'active'">{{account.status}}</span>
                  </td>
                  <td class="text-center">
                    <ul class="icons-list">
                      <li class="dropdown">
                        <a href="" class="dropdown-toggle" data-toggle="dropdown">
                          <i class="icon-menu9"></i>
                        </a>

                        <ul class="dropdown-menu dropdown-menu-right">
                          <li>
                            <a href="javascript:void(0);" (click)="editAccount(account)">
                              <i class="icon-file-pdf"></i>Update</a>
                          </li>
                          <li>
                            <a href="">
                              <i class="icon-file-excel"></i>Delete</a>
                          </li>
                          <li class="dropdown-submenu dropdown-submenu-left">
                            <a href="javascript:void(0);">Change Status</a>
                            <ul class="dropdown-menu">
                              <li>
                                <a (click)="changeStatus(account.id,'pending')">
                                  <i class="icon-shuffle"></i> Pending</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(account.id,'active')">
                                  <i class="icon-shuffle"></i> Active</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>

                    </ul>
                  </td>
                </tr>
                <tr *ngIf="accounts.length <=0">
                  <td colspan="6" class="text-center"> <i class="icon-info22">&nbsp;</i>No Accounts registered yet!</td>
                </tr>
              </tbody>
            </table>


            <div class="row">
              <div class="text-center">

                <pagination-controls id="accounts" (pageChange)="pageChanged(currentPage = $event)">
                </pagination-controls>

                <br>
              </div>

            </div>

          </fieldset>
        </div>

        <div class="col-md-1"></div>
        <div class="col-md-5">

          <fieldset>
            <legend class="text-semibold">
              <i class="icon-reading position-left"></i> Account
            </legend>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Bank: </span>
                  <ng-select [items]="banks" placeholder="" formControlName="bank" bindLabel="name"
                    (change)="setAccronym(bank.value)" required>
                  </ng-select>
                  <!-- <ng-select [items]="banks$ | async" [multiple]="true" bindLabel="login" bindValue="login"
                    placeholder="Select bank" [(ngModel)]="selectedUsers">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                      <div class="ng-value" *ngFor="let item of banks | slice:0:2">
                        <span class="ng-value-label"><img [src]="item.avatar_url" width="20px" height="20px">
                          {{item.login}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                      </div>
                      <div class="ng-value" *ngIf="items.length > 2">
                        <span class="ng-value-label">{{items.length - 2}} more...</span>
                      </div>
                    </ng-template>
                  </ng-select> -->
                  <div class="help-block" *ngIf="bank.invalid && (bank.dirty || bank.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Bank is required
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group required">
                  <span class="control-label"> Accronym: </span><br><br>
                  <input type="text" readonly name="accronym" required formControlName="accronym" class="form-control"
                    placeholder="Accronym">
                  <div class="help-block" *ngIf="accronym.invalid && (accronym.dirty || accronym.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Accronym is required
                    </p>
                  </div>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group required">
                  <span class="control-label"> Account Number: </span><br><br>
                  <input type="text" name="account_number" required formControlName="account_number"
                    class="form-control" placeholder="account number">
                  <div class="help-block"
                    *ngIf="account_number.invalid && (account_number.dirty || account_number.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left text-red"></i> Account number is required
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Status: </span><br><br>
                  <select name="status" required formControlName="status" class="form-control"
                    data-placeholder="Select account status">
                    <option selected disabled>Status:</option>
                    <option value="pending">Pending</option>
                    <option value="active">Active</option>
                    <option value="sold">Sold</option>
                  </select>
                  <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Account status is required.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">

              <div class="col-md-12 form-group">
                <label>&nbsp;</label>
                <label>Remark:</label>
                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                  placeholder="Additional information . . ." required></textarea>
                <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Please write small description about the account
                  </p>
                </div>
              </div>
            </div>

          </fieldset>

          <div class="text-right">

            <!--  <button class="btn bg-slate-800" (click)="addNews(account.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
              <span *ngIf="!account.id">Save News</span>
              <span *ngIf="account.id">Update News</span>
              <i class="icon-floppy-disk position-right"></i>
            </button> -->
            <button class="btn bg-slate-800" (click)="addAccount()" type="submit" data-style="slide-right"
              [disabled]="accountForm.invalid">
              <span *ngIf="operation=='add'">Save Account</span>
              <span *ngIf="operation!='add'">Update Account</span>
              <i class="icon-floppy-disk position-right"></i>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</form>
<!-- /2 columns form -->